export enum NotificationFrequency {
    Daily = 1,
    Weekly,
    Instantly,
    Scheduled,
    Ignore,
    Reccurent,
}